var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.666748,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D03A94",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_6878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 30.6667C25.523 30.6667 30 26.1897 30 20.6667C30 15.1437 25.523 10.6667 20 10.6667C14.477 10.6667 10 15.1437 10 20.6667C10 26.1897 14.477 30.6667 20 30.6667Z",
    fill: "#D03A94",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6667C21.5913 26.6667 23.1174 26.0346 24.2426 24.9094C25.3679 23.7842 26 22.258 26 20.6667C26 19.0754 25.3679 17.5493 24.2426 16.4241C23.1174 15.2989 21.5913 14.6667 20 14.6667C18.4087 14.6667 16.8826 15.2989 15.7574 16.4241C14.6321 17.5493 14 19.0754 14 20.6667C14 22.258 14.6321 23.7842 15.7574 24.9094C16.8826 26.0346 18.4087 26.6667 20 26.6667Z",
    fill: "#D03A94",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.6667C20.5304 22.6667 21.0391 22.456 21.4142 22.081C21.7893 21.7059 22 21.1972 22 20.6667C22 20.1363 21.7893 19.6276 21.4142 19.2525C21.0391 18.8775 20.5304 18.6667 20 18.6667C19.4696 18.6667 18.9609 18.8775 18.5858 19.2525C18.2107 19.6276 18 20.1363 18 20.6667C18 21.1972 18.2107 21.7059 18.5858 22.081C18.9609 22.456 19.4696 22.6667 20 22.6667Z",
    fill: "#D03A94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_6878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10.6667)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.4b87fdb5d64735f691a0ff1b47c37b30.svg";
export { ForwardRef as ReactComponent };